module.exports = __webpack_public_path__ + "img/LSSGreenBelt.f9afb08d.jpg";